export default {"src":"/_next/static/media/bank_icon.b34eb775.svg","height":19,"width":23,"blurWidth":0,"blurHeight":0};